// The thumbnail a pose tile shows in the pose pickers (LoraModal, ExtendModal).
//
// Pony and Flame models show per-model art at /assets/loras/pony[Anime][Gay|Lesbian]/<title>.webp.
// Other models show the pose's own `src` (photoreal) or `animeSrc`. Some poses have no art under
// the pony folders; their tile used to request the built path, 404 and fall back to `src` via
// onError (about 120,000 wasted requests a week, 2026-09-28). Those poses carry `thumbFromSrc: true`
// in the `loras` data and go straight to the art they were already showing.
// `node scripts/check-pose-thumbnails.mjs` lists any built path with no file in public/.

export const animeModels = [
  'Anime',
  'Hyperanime',
  'Fur',
  'Furtoon',
  'Anime XL',
  'Pony Anime XL',
  'Pony Render XL',
  'Pony Illustration XL',
  'Anime Flame',
]

// The pose's own art for this model: also what the tile's onError falls back to.
export const poseOwnThumb = (image, model) =>
  animeModels.includes(model)
    ? image.animeSrc || image.src
    : image.src || image.animeSrc

export const poseThumb = (image, model) => {
  const anime = animeModels.includes(model)
  if (!(model.includes('Pony') || model.includes('Flame'))) {
    return poseOwnThumb(image, model)
  }
  // Extend-only poses ("Same Pose", the freestyle "Custom") exist only in ExtendModal and have
  // no per-model art.
  if (image.thumbFromSrc || image.freestyle || image.title === 'Same Pose') {
    return poseOwnThumb(image, model)
  }
  // "Default" has pony art only for anime models (ponyAnime/Default.webp). The non-anime tile has
  // always shown its fallback, random.webp; pony/default.webp (a portrait, lower-case name) was
  // never displayed, so keep what users see.
  if (image.title === 'Default' && !anime) return poseOwnThumb(image, model)
  const orientation = image.title.includes('Gay')
    ? 'Gay'
    : image.title.includes('Lesbian')
      ? 'Lesbian'
      : ''
  return `/assets/loras/pony${anime ? 'Anime' : ''}${orientation}/${image.title}.webp`
}
